import styled from "@emotion/styled";
import { KalturaESearchCategoryResult } from "kaltura-typescript-client/api/types/KalturaESearchCategoryResult";
import { Box } from "@kaltura/mediaspace-shared-styled";
import ChannelItem from "./../channel-item/ChannelItem";
import ChannelItemEmpty from "./../channel-item/ChannelItemEmpty";
import { ReactNode } from "react";

export interface ChannelsListProps {
    channels: KalturaESearchCategoryResult[];
    numberOfItemsToShow: number;
}

const StyledChannelListWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    gap: theme.spacing(2),
}));

const StyledChannelsList = styled("ul")(({ theme }) => ({
    display: "flex",
    flexGrow: 1,
    gap: theme.spacing(2),
    justifyContent: "space-between",
    padding: 0,
    margin: 0,
}));

const StyledEmptyList = styled("div")(({ theme }) => ({
    display: "flex",
    flexGrow: 1,
    gap: theme.spacing(2),
    justifyContent: "space-between",
    padding: 0,
    margin: 0,
}));

/**
 * component that displays the required number of channels
 */
export function ChannelsList({ channels, numberOfItemsToShow }: ChannelsListProps) {
    const channelsToShow = channels.slice(0, numberOfItemsToShow);
    const components = channelsToShow.map((channel, ind) => <ChannelItem searchResult={channel} key={`cnl_${ind}`} />);

    // add empty items to keep the gap right
    const emptyItems: ReactNode[] = [];
    const missingItems = numberOfItemsToShow - channelsToShow.length;
    if (missingItems) {
        for (let i = 0; i < missingItems; i++) {
            emptyItems.push(<ChannelItemEmpty key={`e_cnl_${i}`} />);
        }
    }

    return (
        <StyledChannelListWrapper>
            <StyledChannelsList className="kms-ds-global-search-channel-results-channels-list">
                {components}
            </StyledChannelsList>
            {emptyItems.length > 0 && <StyledEmptyList role={"presentation"}>{emptyItems}</StyledEmptyList>}
        </StyledChannelListWrapper>
    );
}

export default ChannelsList;
